module.exports = __webpack_public_path__ + "f73389ad7fef45743e95b280cba37ed2.jpg";